export default __webpack_public_path__ + "static/media/_unknown.d49b8872.ico";